interface SectionWrapperProps {
  children: React.ReactNode;
  className?: string;
}

const SectionWrapper: React.FC<SectionWrapperProps> = ({ children, className = '' }) => {
  return (
    <div className={`mb-8 ${className}`}>
      <div className='rounded-3xl border border-[var(--Greys-900,#18181B)] bg-[rgba(255,255,255,0.02)] p-8 py-14 backdrop-blur-sm'>
        <div className='mx-auto w-full md:w-3/4'>{children}</div>
      </div>
    </div>
  );
};

export default SectionWrapper;
